export default function test(str) {
    if (!str) return true;
    // regexp based check, allow only digits
    return /^[+-]?[0-9]+\.[0-9]+$/.test(str);
}